<div class="home-rides-list list-container">
  <h1 class="mat-h1 rides-list-header" i18n>Recent Rides</h1>
  <pii-my-rides
    [displayRideButton]="true"
    (createPlanRide)="createPlanRide($event)"
    (importRide)="importRide.emit()"
    (selectRide)="navigateToRide($event)"
    (initialRidesLoaded)="initialRidesLoaded = $event"
    (ridesLength)="ridesLength = $event"
  />
  @if (!initialRidesLoaded || ridesLength) {
    <div class="helper-align-right rides-list-controls-container">
      <ul class="list-inline">
        <li>
          <rdx-plan-ride-button
            [entityType]="'Home'"
            (startRidePlanningClicked)="navigateToUrl('/map/planned-ride/create')"
          />
        </li>
        <li>
          <a id="importRideFromHome" href="javascript:void(0);" (click)="importRide.emit()" i18n>Import Ride</a>
        </li>
        <li>
          <a id="viewAllRideFromHome" href="javascript:void(0);" (click)="navigateToUrl('/rides/planned-ride')" i18n
            >View All</a
          >
        </li>
      </ul>
    </div>
  }
</div>
